module.exports = __webpack_public_path__ + "img/70.5.COD.4a9a62d6.png";